import React, { useState } from "react";
import "./IncompletePaymentPage.css";
import { Link } from "react-router-dom";
import backIcon from "./icons/keyboard_backspace-24px.svg";
import { loadStripe } from "@stripe/stripe-js";
import CreateStripeSessionMutation from "./mutations/stripe-mutations/CreateStripeSessionMutation";
import { useTheme } from "./contexts/ThemeContext";
import tickIcon from "./icons/tick_icon.svg";
import AccountDetailsContainer from "./AccountDetailsContainer";

function IncompletePaymentPage(props) {
    const theme = useTheme();

    function onTrialButtonClick(e) {
        e.preventDefault();
    }

    return (
        <div className={`paywall-page-wrapper`}>
            <div className={`settings-header header header-fixed-true`}>
                <div
                    className={`paywall-settings-header-room paywall-header-room-true`}
                >
                    <div className={`settings-header-controls`}>
                        <Link to="/home">
                            {" "}
                            <img className="back-icon" src={backIcon} />{" "}
                        </Link>
                    </div>
                </div>
            </div>
            <div className="xpaywall-container">
                <div className="costomer-portal-link-container">
                    <div className={`complete-payment-page-body`}>
                        <h2 className="portal-redirect-title-small">
                            Analyse articles to find the most important topics
                            and more.{" "}
                        </h2>
                        <h2 className="portal-redirect-title">
                            Your are only one step away to make it!!
                        </h2>
                        <AccountDetailsContainer
                            settings={props.settings}
                            user={props.user}
                            title={`Incomplete payment! Update billing info.`}
                            style={{
                                fontSize: "1.2rem",
                                color: "orangered",
                            }}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default IncompletePaymentPage;
